export default function Event() {
  return (
    <>
      <div>대회용 방도 아직안만드럿서</div>
    </>
  );
}
